<template>
  <AppHeaderDropdown right no-caret v-if="isLogged">
    <template slot="header">
    {{ username }}
      <img
        src="img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item to="/dashboard"><i class="fa fa-bell-o" /> Dashboard
        <!--<b-badge variant="info">{{ itemsCount }}</b-badge>-->
      </b-dropdown-item>
      <!--<b-dropdown-item><i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-tasks" /> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item>-->
      <!--<b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>-->
      <!--<b-dropdown-item>
        <i class="fa fa-user" /> Profile
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-wrench" /> Settings
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">
          {{ itemsCount }}
        </b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-file" /> Projects
        <b-badge variant="primary">
          {{ itemsCount }}
        </b-badge>
      </b-dropdown-item>-->
     <!-- <b-dropdown-divider />-->
     <!-- <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item>-->
      <b-dropdown-item v-if="$can('Reset_Password_Own', 'all')">
        <router-link to="/user/user-profile">
          <i class="fa fa-lock" /> Profile
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item>
        <router-link to="/logout">
            <i class="fa fa-lock" /> Logout
        </router-link>
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
  <div v-else>
 <ul class="nav navbar-nav d-md-down-none">
  <li class="nav-item px-3">
    <a class="nav-link" href="#">
      <router-link to="/login">
            Login
      </router-link>
    </a>
  </li>
</ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
        itemsCount: 42 ,
        username: ""
      
      }
  },
   computed: {
    ...mapState("login", ["user_name","access_token"]),

    isLogged() {
       return this.access_token !== null;
    }

  },
  mounted() {
    if(this.user_name != ""){
        this.username = this.user_name;
    }
  }
}
</script>

<style scoped>

  .app-header .dropdown-menu {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 8px 0 rgba(0, 0, 0, 0.05);
    border-bottom: 0px solid #c8ced3 !important;
    border-radius: 0.25rem;
  }

</style>